(function () {
  'use strict';

  angular
    .module('userActivityReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('userActivityReport', {
        url: '/user-activity-report',
        views: {
          'userActivityReportView': {
            templateUrl: 'user-activity-report/views/user-activity-report.tpl.html',
            controller: 'UserActivityReportCtrl',
            controllerAs: 'userActivityReport'
          }
        }
      });
  }
}());
